/* eslint no-unused-vars: ["error", { "args": "none" }] */
export default class BrowserStorage {
  static getStorageObject() {
    const kind = 'sessionStorage';
    if ((kind in window) && window.kind !== null) {
      return window.sessionStorage;
    }
    return { // NULL storage
      setItem(key, value) {},
      getItem(key) { return null; },
      clear() {},
      removeItem(key) {},
    };
  }

  static setItem(tag, key, item) {
    this.privateSetTagKey(tag, key);
    this.privateSetItem(key, item);
  }

  static getItem(key) {
    return this.getStorageObject().getItem(key);
  }

  static privateSetTagKey(tag, key) {
    const keys = this.privateGetTagKeys(tag);
    keys.push(key);
    this.privateSetItem(this.privateGetTagKey(tag), JSON.stringify(keys));
  }

  static privateSetItem(key, value) {
    this.getStorageObject().setItem(key, value);
  }

  static privateGetTagKeys(tag) {
    return JSON.parse(this.getItem(this.privateGetTagKey(tag))) || [];
  }

  static privateGetTagKey(tag) {
    return `tag-key-${tag}`;
  }

  static removeTagItems(tag) {
    this.privateGetTagKeys(tag).forEach((key) => {
      this.removeItem(key);
    });
    this.removeItem(this.privateGetTagKey(tag));
  }

  static removeAllItems() {
    this.getStorageObject().clear();
  }

  static removeItem(key) {
    this.getStorageObject().removeItem(key);
  }
}
